import { CustomerExclusivity } from "./ProductDetailPageResult";
import { User } from "~/common/Store/models/User";

export default (customerExclusivity?: CustomerExclusivity, user?: User) => {
  return !!(
    !customerExclusivity?.disallowNonMemberToPurchase ||
    (customerExclusivity?.allowPlatinumToPurchase && user?.platinum?.enabled) ||
    (customerExclusivity?.allowWebstaurantPlusToPurchase && user?.hasWebPlus)
  );
};
